<template>
  <div class="users-bg">
    <mainHeader></mainHeader>
    <div class="container">
      <div class="row has-header">
        <div class="mt-24">
          <span class="color_team ml-12 cursor_pointer" v-on:click="goToAllTeams">Team</span>
          <span class="color_profile">&nbsp;/ Profile</span>
        </div>
      </div>
      <div class="row p-15">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 card-container">
          <div class="team-card">
            <div class="row header-container" v-if="userId == '0'">
              <div class="col">
                <div class="add-team-header">
                  Add Team Member
                </div>
              </div>
              <div class="col text-right" v-if="canAccessBatchUpload">
                <div class="btn import-btn file-upload mr-20">
                  <label class="custom-file-upload">
                    <input type="file" accept=".csv" class="file-input" id="file_upload" @change="onFileChange($event)" />
                    <span> <img src="static/img/batch-upload.svg" class="pl-4 pr-7 img-mr" />Batch Upload </span>
                  </label>
                </div>
                <div class="btn import-btn" @click="downloadTemplate()"><img src="static/img/download.svg" class="pl-4 pr-7 img-mr" />Download Batch Upload Template</div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label class="name-txt">NAME</label>
                <div class="form-group row" :class="{ 'mb-0': errors.has('firstName') }" v-if="editable || addEnable">
                  <label class="col-4 mb-0">First Name:</label>
                  <div class="col-8 mb-0">
                    <input
                      type="text"
                      v-validate="{ required: true, regex: /^[A-Za-z- ]+$/ }"
                      name="firstName"
                      v-if="editable || addEnable"
                      v-model="userDetails.firstName"
                      class="input-txt-2"
                      :class="{
                        input: true,
                        'is-danger': errors.has('firstName'),
                        'is-success': !errors.has('firstName')
                      }"
                      placeholder="Enter first name"
                    />
                    <span v-show="errors.has('firstName')" class="error-style" v-if="editable || addEnable">{{ showErrorMsg(errors, "firstName") }}</span>
                  </div>
                </div>
                <div class="form-group row" :class="{ 'mb-0': errors.has('lastName') }" v-if="editable || addEnable">
                  <label class="col-4 mb-0">Last Name:</label>
                  <div class="col-8 mb-0">
                    <input
                      type="text"
                      v-validate="{ required: true, regex: /^[A-Za-z- ]+$/ }"
                      name="lastName"
                      v-if="editable || addEnable"
                      v-model="userDetails.lastName"
                      class="input-txt-2"
                      :class="{
                        input: true,
                        'is-danger': errors.has('lastName'),
                        'is-success': !errors.has('lastName')
                      }"
                      placeholder="Enter last name"
                    />
                    <span v-show="errors.has('lastName')" class="error-style" v-if="editable || addEnable">{{ showErrorMsg(errors, "lastName") }}</span>
                  </div>
                </div>
                <span type="text" v-if="!editable && !addEnable" class="form-control input-txt" placeholder="" :disabled="!editable">{{ userDetails.firstName }} {{ userDetails.lastName }}</span>
              </div>
              <div v-if="awsCognitoAuthentication && awsCognitoAuthentication === true && userId && userId != 0" class="col">
                <label class="name-txt">USERNAME</label>
                <input
                  type="text"
                  v-validate="'required'"
                  name="username"
                  :class="{
                    input: true,
                    'is-danger': errors.has('username'),
                    'is-success': !errors.has('username')
                  }"
                  class="input-txt"
                  v-model="userDetails.cognitoUsername"
                  placeholder=""
                  required
                  :disabled="true"
                />
                <span v-show="errors.has('username')" class="error-style">{{ errors.first("username") }}</span>
              </div>
              <div class="col">
                <label class="name-txt">EMAIL</label>
                <input
                  type="email"
                  v-validate="'required|email'"
                  name="email"
                  :class="{
                    input: true,
                    'is-danger': errors.has('email'),
                    'is-success': !errors.has('email'),
                    'input-txt': !addEnable,
                    'edit-email-input': !disableEmailField
                  }"
                  v-model="userDetails.username"
                  placeholder="Enter email"
                  required
                  :disabled="disableEmailField"
                />
                <span v-show="errors.has('email')" class="error-style" v-if="editable || addEnable">{{ errors.first("email") }}</span>
              </div>
              <div class="col">
                <label class="name-txt"
                  >ROLE
                  <i v-if="user.userRole === 'Support'" class="fa fa-question-circle help_icon" aria-hidden="true" data-toggle="popover" tabindex="0" data-trigger="focus" data-content=" 1.Clinical Research Associate <br> 2.Data Management <br> 3.Quality <br> 4.Biostatistics <br> 5.Pharmacovigilance <br> 6.Interviewer <br> 7.Translations" data-html="true"></i>
                  <i
                    v-else-if="user.userRole === 'SystemAdmin'"
                    class="fa fa-question-circle help_icon"
                    aria-hidden="true"
                    data-toggle="popover"
                    tabindex="0"
                    data-trigger="focus"
                    data-content=" 1.Platform Admin <br> 2.Study admin <br> 3.Clinical Research Associate <br> 4.Data Management <br> 5.Quality <br> 6.Study Manager <br> 7.Biostatistics <br> 8.Pharmacovigilance <br> 9.Interviewer <br> 10.Translations <br> 11.Support"
                    data-html="true"
                  ></i>
                  <i v-else class="fa fa-question-circle help_icon" aria-hidden="true" data-toggle="popover" tabindex="0" data-trigger="focus" data-content=" 1.Platform Admin <br> 2.Study admin <br> 3.Clinical Research Associate <br> 4.Data Management <br> 5.Quality <br> 6.Study Manager <br> 7.Biostatistics <br> 8.Pharmacovigilance <br> 9.Interviewer <br> 10.Translations" data-html="true"></i>
                </label>
                <select name="userRole" v-model="userDetails.userRole" class="form-control ml-14 input-md inner-card-value select-font minWidthSelect" :disabled="isUserRoleFieldDisabled">
                  <option disabled value=""> Select Role</option>
                  <option v-for="role in userRolesList" v-bind:value="role.value" :key="role.value"> {{ role.name }}</option>
                </select>
                <span v-show="errors.has('userRole')" class="error-style" v-if="!editable">User role is mandatory</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label class="name-txt">MOBILE</label>
                <span :class="{ 'input-display': !editable && !addEnable }">
                  <vue-tel-input class="vue-tel-input p-0 ml-13 mb-7" @onInput="onInputUserPhone" ref="userPhoneNumber"></vue-tel-input>
                  <span v-if="userDetails.phoneNumber && userDetails.phoneNumber.length > 0 && !validMobile" class="error-style">Phone number is invalid</span>
                </span>
                <input class="input-txt" :disabled="!editable && !addEnable" v-model="userDetails.phoneNumber" v-if="!editable && !addEnable" />
              </div>
              <div class="col">
                <label class="name-txt">WORK</label>
                <span :class="{ 'input-display': !editable && !addEnable }">
                  <vue-tel-input class="vue-tel-input-1 p-0 ml-13 mb-7" @onInput="onInputWorkNumber" ref="userWorkNumber"></vue-tel-input>
                  <span v-if="userDetails.workNumber && userDetails.workNumber.length > 0 && !validWork" class="error-style">Work number is invalid</span>
                </span>
                <input class="input-txt" type="text" v-if="!editable && !addEnable" :disabled="!editable && !addEnable" v-model="userDetails.workNumber" />
              </div>
              <div class="col" v-if="addEnable"></div>
              <div class="col">
                <label class="name-txt">Status</label>
                <select name="status" v-model="userDetails.status" class="form-control input-md inner-card-value width100 float-left select-font" placeholder="Active" :disabled="isStatusFieldDisabled">
                  <option value="Active" v-if="userStatus != 'Pending'">Active</option>
                  <option value="Pending" :disabled="userStatus == 'Pending'" v-if="isShowPending">Pending</option>
                  <option value="Inactive" v-if="userDetails.status === 'Active' || userDetails.status === 'Inactive' || userStatus == 'Pending'">Inactive</option>
                </select>
                  <button type="button" class="btn btn-md resend-invite" v-if="userDetails.status == 'Pending'" v-on:click="sendInvite(userId, userDetails)">
                    Resend invite
                  </button>
                </div>
              </div>
              <div v-if="canAccessSSOUsername" class="additional-details-sso">
              <span class="line"></span>
              <div class="additional-sso-title">Additional Details for SSO</div>
              <div class="desc">Important! Please do not populate this section unless this user’s account is associated with an SSO Identity Provider.</div>
              <div class="row no-gutters">
                <div class="col-4">
                  <div class="form-group">
                    <label class="mb-4">IDP Username</label>
                    <input type="text" name="idpUserName" v-if="editable || addEnable" v-model="userDetails.idpUserName" class="input-txt-2" :class="{ input: true, 'is-danger': errors.has('idpUserName'), 'is-success': !errors.has('idpUserName') }" placeholder="Enter IDP Username" />
                    <input type="text" v-if="!editable && !addEnable" class="read-only-username" :value="userDetails.idpUserName" disabled>
                    <span v-show="errors.has('idpUserName')" class="error-style" v-if="editable || addEnable">{{ showErrorMsg(errors, "idpUserName") }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="canSysAdminAccess && userDetails.userRole === 'StudyAdmin'">
              <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mt-10">
                <span class="pr-5 fs-15 d-inline-block" style="margin-bottom: 1rem;">Manage Activity Library</span>
                <span class="fa fa-info-circle info-circle" aria-hidden="true" @click="toggleInfoDiv()" @blur="hidePopup()" tabindex="-1"></span>
                <div class="info-circle-div" v-show="infoDiv">
                  Enabling the Manage Activity Library privilege will allow the member to create, modify, and archive activities in your instance's activity library.
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mt-12 toggle-margin">
                <div class="switch-button d-flex">
                  <span class="setting-btn-text">Off</span>
                  <div class="switch-option">
                    <label class="switch">
                      <input type="checkbox" v-if="!editable && !addEnable" :disabled="!editable && !addEnable" @click="switchActivityLibrary(activityLibraryStatus)" v-model="userDetails.activityLibraryAllowed" />
                      <input type="checkbox" v-if="editable && !addEnable" @click="switchActivityLibrary(activityLibraryStatus)" v-model="userDetails.activityLibraryAllowed" />
                      <div class="slider round"></div>
                    </label>
                    <span class="setting-btn-text">On</span>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-4 card-height"></div>
            </div>
            <div class="row studies-managing" v-if="userDetails.userRole == 'Dm' || userDetails.userRole == 'Quality' || userDetails.userRole == 'StudyAdmin' || userDetails.userRole == 'Interviewer' || userDetails.userRole == 'StudyManager' || userDetails.userRole == 'Biostatistics' || userDetails.userRole == 'Pharmacovigilance'">
              <div class="col-md-12 col-sm-12 card-height-2">
                <p class="inner-card">Studies managing</p>
                <span v-for="(study, index) in userDetails.studies" :key="index">{{ study.name }},</span>
                <select name="userRole" v-if="allStudies" v-model="selectedStudy" class="form-control input-md inner-card-value-study select-font mb-20" placeholder="Study managing" v-on:change="studySelected(selectedStudy)" :disabled="!editable && !addEnable">
                  <option disabled value="Study admin">Study admin</option>
                  <option v-for="(study, index) in allStudies" v-bind:value="study" :key="index">{{ study.name }}</option>
                </select>
              </div>
            </div>
            <div class="row mt-95">
              <div class="text-center ml-405  mt-43 mb-20" style="margin:0 auto;">
                <button type="button" class="btn btn-md cancel-btn cancle-margin" v-if="editable || addEnable" v-on:click="goToAllTeams">
                  Cancel
                </button>
                <button type="button" class="btn btn-md save-btn" data-testid="save-user-btn" v-if="editable || addEnable" v-on:click="saveUserInfo(userId, userDetails)">
                  Save
                </button>
              </div>
              <span :class="editable ? 'Change-password-2' : 'Change-password'" data-toggle="modal" v-if="!addEnable && (userDetails.idpUserName == '' || !userDetails.idpUserName)" data-target="#reset-password-modal">Change password</span>
              <span type="button" class="edit-box" v-if="showEditBtn" v-on:click="goToEditProfile">Edit</span>
            </div>
          </div>
        </div>
      </div>
      <div class="contents" v-if="!editable && !addEnable">
        <assignedStudies v-if="isDataLoaded && allowedRoleForAssignedStudiesSection" :canChangeLiveTestDataAccess="canChangeLiveTestDataAccess" :userDetails="userDetails" :allStudies="allStudies" :userRoleHistory="userDetails.userRoleHistory" @dataAccessChangeChild="dataAccessChangeParent" @reloadUserProfile="getUserDetails(userId)" />
        <span v-else-if="isDataLoaded">
          <span v-if="userDetails.isSiteTeamUser">
            <studySiteAssociation :data="userDetails.userSite" :userRole="userDetails.userRole" :isSiteTeamUser="userDetails.isSiteTeamUser" @siteTeamStatusToggleChild="siteTeamStatusToggleParent" :isProfile="false" :userRoleHistory="userDetails.userRoleHistory"> </studySiteAssociation>
          </span>
          <span v-if="!userDetails.isSiteTeamUser">
            <studySiteAssociation :data="userDetails.userStudies" :userRole="userDetails.userRole" :isSiteTeamUser="userDetails.isSiteTeamUser" @studyTeamActiveStatusChild="studyTeamActiveStatusParent" @studyTeamDeactiveStatusChild="studyTeamDeactiveStatusParent" @dataAccessChangeChild="dataAccessChangeParent" :isProfile="false" :userRoleHistory="userDetails.userRoleHistory">
            </studySiteAssociation>
          </span>
        </span>
      </div>
      <div class="row bottom_footer">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <p class="text-center color_top foot-style-text">
            Questions or need help ?
          </p>
          <Copyright class="color_top" />
        </div>
      </div>
    </div>
    <div id="reset-password-modal" class="modal fade modal-position" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <p class="maroon_color modal-text">Password reset</p>
          <div class="modal-body modal-style">
            <p class="modal-instruction">
              Are you sure you want to reset the
              <b>{{ userDetails.firstName }}</b
              >'s password ?
            </p>
            <p class="modal-instruction">
              A password reset link will be sent to
              {{ userDetails.firstName }} 's email
            </p>
          </div>
          <div class="form-group text-center p-15">
            <button class="btn btn-lg btn-block yes-btn btn-info-blue mb-10 br-30" data-dismiss="modal" v-on:click="resetPassword(userId)">
              Yes
            </button>
            <button class="btn btn-lg btn-block yes-btn btn-info-blue br-30" data-dismiss="modal" v-on:click="cancelResetPassword">
              No
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="user-import-modal" class="modal user-import-modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content width-650 height-250 pl-24">
          <div class="modal-header border-none">
            <h3 class="modal-title invite-text color_2d3752">
              <b>Batch Upload</b>
            </h3>
            <button type="button" class="close" data-dismiss="modal" @click="closeImportModal">
              &times;
            </button>
          </div>
          <div class="modal-body pl-0 pt-6">
            <div class="row pb-50 color_4a4a4a">
              <div class="modal-description">
                <b
                  >You are about to upload {{ fileLength }} <span v-if="fileLength > 1">users</span><span v-else>user</span> from <span :title="uploadFileName">{{ uploadFileName }}.</span></b
                >
              </div>
              <div>
                <p><b>Please select "Continue" to confirm.</b></p>
              </div>
            </div>
            <div class="row text-center display-block">
              <button class="btn cancel-btn br-3 width100 mr-15" @click="closeImportModal">
                Cancel
              </button>
              <button class="btn blue-btn br-3 width100" @click="importCSV(setImportValue)">
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="uploading-modal" class="modal uploading-modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content width-350 height-250 pl-24">
          <div class="modal-body pt-40 text-center color_2d3752">
            <div class="row display-block">
              <h3>
                <b>Loading Users</b>
              </h3>
            </div>
            <div class="fs-16">Thanks for your patience</div>
            <div class="pt-20">
              <b-progress :value="uploadingValue" :max="100" height="6px" variant="success"></b-progress>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="download-report-modal" class="modal download-report-modal fade" role="dialog">
      <div class="modal-dialog" role="document">
        <!-- Modal content-->
        <div class="modal-content width-650">
          <div class="modal-header border-none">
            <h3 class="modal-title invite-text color_2d3752">
              <b>Batch Upload</b>
            </h3>
            <button type="button" class="close" data-dismiss="modal" @click="closeDownloadModal">
              &times;
            </button>
          </div>
          <div class="row color_e74c3c download-modal pt-10 pb-6" v-if="downloadList.skippedUsersCount > 0">
            <b>{{ downloadList.skippedUsersCount }} user(s) failed to upload.</b>
          </div>
          <div class="bb-e4e8eb" v-if="downloadList.skippedUsersCount > 0"></div>
          <div class="autoScroll">
            <div class="row download-modal pt-6 color_4a4a4a" v-for="(user, index) in downloadList.skippedUsers" :key="index">
              {{ user.email }}
            </div>
          </div>
          <div class="modal-body p-0">
            <div class="row download-modal pt-30">
              <button class="btn blue-btn br-3" @click="exportCSV()">
                Download report
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import jwt from 'jwt-decode';
import { SYSTEM_ADMIN, SUPPORT, STUDY_ADMIN } from "@/constants/authRoles";
import toastr from "toastr";
import mainHeader from "../common/main-header";
import Copyright from "../common/copyright";
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";
import studySiteAssociation from "./study-site-association";
import swal from "sweetalert2";
import _ from "lodash";
import $ from "jquery";
import Papa from "papaparse";
import filter from "lodash/filter";
import FileSaver from "file-saver";
import eventBus from "@/eventBus";
import axios from "axios";
import localStorageService from "@/services/localStorage";
import assignedStudies from "@/components/users/assigned-studies";

export default {
  name: "add-edit-user",
  data() {
    return {
      userId: null,
      editable: false,
      addEnable: false,
      showEditBtn: false,
      allStudies: [],
      validMobile: false,
      validWork: false,
      infoDiv: false,
      activityLibraryStatus: false,
      userDetails: {
        name: "",
        firstName: "",
        username: "",
        phoneNumber: "",
        workNumber: "",
        userStatus: "",
        userRole: "",
        lastName: "",
        studies: [],
        siteTeamUser: "",
        idpUserName: ""
      },
      unchangedUserDetails: null,
      selectedStudy: null,
      managedStudies: "",
      roles: [
        { name: "Platform Admin", value: "SystemAdmin" },
        { name: "Study Admin", value: "StudyAdmin" },
        { name: "Clinical Research Associate (Blinded)", value: "Cra" },
        { name: "Clinical Research Associate (Unblinded)", value: "CraUB" },
        { name: "Data Management", value: "Dm" },
        { name: "Quality", value: "Quality" },
        { name: "Study Manager", value: "StudyManager" },
        { name: "Biostatistics", value: "Biostatistics" },
        { name: "Translations", value: "Translations" },
        { name: "Pharmacovigilance", value: "Pharmacovigilance" },
        { name: "Interviewer", value: "Interviewer" },
        { name: "Support", value: "Support" }
      ],
      siteRoles: [
        { name: "Principal Investigator", value: "Pi" },
        { name: "Sub-Investigator", value: "SubPi" },
        { name: "Site - Data Lock", value: "SiteDataLock" },
        { name: "Home Health", value: "HomeHealth" },
        { name: "Study Coordinator", value: "StudyCoordinator" },
        { name: "Call Center", value: "CallCenter" },
        { name: "Rater", value: "Rater" }
      ],
      selectedRole: "",
      isDataLoaded: false,
      userStatus: "",
      fileLength: 0,
      downloadList: {},
      setImportValue: null,
      uploadFileName: "",
      uploadingValue: 0
    };
  },
  computed: {
    ...mapGetters(["user", "awsCognitoAuthentication"]),
    isShowPending() {
      return !(this.userDetails.status == "Active" || this.userDetails.status == "Inactive" || this.userDetails.accountLocked);
    },
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    },
    canAccessSSOUsername() {
      if (this.awsCognitoAuthentication && this.awsCognitoAuthentication === true && (this.canSysAdminAccess || this.canStudyAdminAccess || this.canSupportAccess)) {
        return true;
      }
      return false;
    },
    canAccessBatchUpload() {
      return this.canSysAdminAccess || this.canStudyAdminAccess || this.canSupportAccess;
    },
    disableEmailField() {
      if (this.addEnable) {
        return false;
      } else if (this.awsCognitoAuthentication === true && (this.addEnable || this.editable)) {
        return false;
      } else {
        return true;
      }
    },
    userRolesList() {
      if (this.addEnable) {
        // When adding a new user, show all (study + admin) roles.
        let userList = null;
        if (this.user.userRole === "Support") {
          userList = this.roles.filter(role => {
            return role.value !== "SystemAdmin" && role.value !== "StudyAdmin" && role.value !== "StudyManager" && role.value !== "Support";
          });
        } else if (this.user.userRole !== "SystemAdmin") {
          userList = this.roles.filter(role => role.value !== "Support");
        } else {
          userList = this.roles;
        }
        return userList;
      } else if (!this.addEnable) {
        let roleList = null;
        if (this.userDetails.userRole !== "SystemAdmin") {
          roleList = _.union(this.roles, this.siteRoles).filter(role => role.value !== "SystemAdmin");
        } else {
          roleList = _.union(this.roles, this.siteRoles);
        }
        return roleList;
      }
      return [];
    },
    isUserRoleFieldDisabled() {
      if (this.addEnable) {
        return false;
      } else if (this.showEditBtn) {
        return true;
      } else if (!this.showEditBtn && this.userDetails.userRole === "SystemAdmin") {
        return true;
      } else if (this.userDetails.status === "Inactive") {
        return true;
      } else if (this.userStatus !== this.userDetails.status) {
        return true;
      }
      return false;
    },
    isStatusFieldDisabled() {
      if (this.addEnable) {
        return true;
      } else if (this.unchangedUserDetails && this.unchangedUserDetails.userRole !== this.userDetails.userRole) {
        return true;
      } else if (!this.editable) {
        return true;
      }
      return false;
    },
    allowedRoleForAssignedStudiesSection() {
      let allowedRoles = ["cra", "craub"];
      return allowedRoles.includes(this.userDetails.userRole.toLowerCase());
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    },
    canChangeLiveTestDataAccess() {
      return (this.canSysAdminAccess || this.canStudyAdminAccess || this.canSupportAccess) && !this.userDetails.isSiteTeamUser;
    }
  },
  mounted() {
    window.$('[data-toggle="popover"]').popover();
    this.getAllStudies();
    this.userId = this.$route.params.userId;
    if (this.userId == "0") {
      this.addEnable = true;
      this.showEditBtn = false;
    } else {
      this.showEditBtn = true;
      this.editable = false;
      this.addEnable = false;
      this.getUserDetails(this.userId);
    }
    eventBus.$on("handleUploadProgress", e => {
      this.uploadingValue = (e.loaded / e.total) * 100;
    });
  },
  methods: {
    switchActivityLibrary() {
      this.$store.state.user.user.activityLibraryAllowed = this.userDetails.activityLibraryAllowed;
    },
    toggleInfoDiv() {
      if (this.infoDiv) {
        this.hidePopup();
      } else {
        this.showPopup();
      }
    },
    showPopup() {
      this.infoDiv = true;
      this.$el.focus();
    },
    hidePopup() {
      this.infoDiv = false;
      this.$el.blur();
    },
    onInputUserPhone({ number, isValid, country }) {
      this.validMobile = isValid;
      const numberCopy = number;
      let phoneNoCopy = "";
      if (typeof numberCopy === "object") {
        if (numberCopy.input.toString().includes("+" + country.dialCode)) {
          phoneNoCopy = numberCopy.input
            .toString()
            .replace(country.dialCode, "")
            .replace(/\s/g, "")
            .replace(/[^a-zA-Z0-9 ]/g, "");
        } else {
          phoneNoCopy = numberCopy.input
            .toString()
            .replace(/\s/g, "")
            .replace(/[^a-zA-Z0-9 ]/g, "");
        }
      } else {
        if (numberCopy.toString().includes("+" + country.dialCode)) {
          phoneNoCopy = numberCopy
            .toString()
            .replace(country.dialCode, "")
            .replace(/\s/g, "")
            .replace(/[^a-zA-Z0-9 ]/g, "");
        } else {
          phoneNoCopy = numberCopy
            .toString()
            .replace(/\s/g, "")
            .replace(/[^a-zA-Z0-9 ]/g, "");
        }
      }
      if (phoneNoCopy.length > 0) {
        this.userDetails.phoneNumber = `+${country.dialCode}${phoneNoCopy.replace(/\s/g, "")}`;
      } else {
        this.userDetails.phoneNumber = "";
      }
    },
    onInputWorkNumber({ number, isValid, country }) {
      this.validWork = isValid;
      const numberCopy = number;
      let phoneNoCopy = "";
      if (typeof numberCopy === "object") {
        if (numberCopy.input.toString().includes("+" + country.dialCode)) {
          phoneNoCopy = numberCopy.input
            .toString()
            .replace(country.dialCode, "")
            .replace(/\s/g, "")
            .replace(/[^a-zA-Z0-9 ]/g, "");
        } else {
          phoneNoCopy = numberCopy.input
            .toString()
            .replace(/\s/g, "")
            .replace(/[^a-zA-Z0-9 ]/g, "");
        }
      } else {
        if (numberCopy.toString().includes("+" + country.dialCode)) {
          phoneNoCopy = numberCopy
            .toString()
            .replace(country.dialCode, "")
            .replace(/\s/g, "")
            .replace(/[^a-zA-Z0-9 ]/g, "");
        } else {
          phoneNoCopy = numberCopy
            .toString()
            .replace(/\s/g, "")
            .replace(/[^a-zA-Z0-9 ]/g, "");
        }
      }
      if (phoneNoCopy.length > 0) {
        this.userDetails.workNumber = `+${country.dialCode}${phoneNoCopy.replace(/\s/g, "")}`;
      } else {
        this.userDetails.workNumber = "";
      }
    },
    studySelected(study) {
      this.userDetails.studies.push(study);
      const data = [];
      data.push({ userId: this.userId });
      this.$api.userAssociateFact(study.studyId, data).then(
        () => {},
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the study team details.");
        }
      );
    },
    getAllStudies() {
      this.$api.getAllStudiesFact().then(
        response => {
          if (response.body) {
            this.allStudies = response.body;
          }
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while getting studies.");
        }
      );
    },
    getUserDetails(userId) {
      this.isDataLoaded = false;
      this.$api.getInstantUserDataFact(userId).then(
        response => {
          this.userStatus = response.body.status;
          this.unchangedUserDetails = _.cloneDeep(response.body); /* To store the unaltered user details for comparisions during editing */
          this.userDetails = response.body;
          this.isDataLoaded = true;
          if (this.userDetails.phoneNumber) {
            this.$refs.userPhoneNumber.phone = this.userDetails.phoneNumber;
            this.validMobile = true;
          }
          if (this.userDetails.workNumber) {
            this.$refs.userWorkNumber.phone = this.userDetails.workNumber;
            this.validWork = true;
          }
          if (this.userDetails.userRole) {
            this.selectedRole = this.userDetails.userRole;
          }
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while getting user details.");
        }
      );
    },
    goToAllTeams() {
      this.$router.push({ name: "users" });
    },
    goToEditProfile() {
      this.$refs.userWorkNumber.phone = "";
      this.$refs.userPhoneNumber.phone = "";
      this.editable = true;
      this.showEditBtn = false;
      setTimeout(() => {
        this.$refs.userWorkNumber.phone = this.userDetails.workNumber;
        this.$refs.userPhoneNumber.phone = this.userDetails.phoneNumber;
      }, 1000);
    },
    saveUserInfo(userId, teamObj) {
      if (teamObj.idpUserName && teamObj.idpUserName.includes(' ')) {
        toastr.error("IdP Username cannot contain spaces.");
        return;
      }
      if (teamObj.idpUserName && teamObj.idpUserName.length > 128) {
        toastr.error("IdP Username should be 128 Characters or less.");
        return;
      }
      if (this.checkHyphen(teamObj) && this.checkPhoneValidation()) {
        this.$validator.validateAll().then(result => {
          if (result) {
            if (this.userId == "0") {
              this.$api.addNewUserInfoFact(teamObj).then(
                () => {
                  if (this.allowedRoleForAssignedStudiesSection) {
                    this.getUserDetailByUserName(teamObj.username);
                  } else {
                    toastr.success("User added successfully");
                    this.$router.push({ name: "users" });
                  }
                },
                error => {
                  toastr.error(error.body && error.body.message ? error.body.message : "Error while adding user.");
                }
              );
            } else {
              if (this.editable) {
                if (this.unchangedUserDetails.userRole !== this.userDetails.userRole) {
                  // If there is a change in user's role.
                  swal({
                    title: "Are you sure you want to change this user’s role?" + "\n" + "Changing the role will automatically deactivate their current role from any associated sites/studies. Once changed, they will need to be manually added to any sites/studies using their new role.",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#4c8ce4",
                    cancelButtonColor: "#e0e0e0",
                    confirmButtonText: "Yes",
                    cancelButtonText: "Cancel",
                    reverseButtons: true
                  }).then(({ dismiss }) => {
                    if (dismiss !== "cancel") {
                      teamObj.isSiteTeamUser = this.isSiteTeamRole(teamObj.userRole);
                      this.updateUserRole(userId, teamObj);
                    }
                  });
                } else {
                  this.updateUserRole(userId, teamObj);
                }
              }
            }
          } else {
            toastr.error("Please fill all the required fields.");
          }
        });
      }
    },
    getUserDetailByUserName(searchTerm) {
      this.$api.userSearchFilterFact(searchTerm.trim(), null, null, true).then(
        response => {
          if (response.body) {
            if (response.body.length === 0) {
              this.$toastr.error("Error while getting user detail.");
              return;
            }

            this.$router.replace({ name: "add-edit-user", params: { userId: response.body[0].id } });
            //Since the $router.replace is just replacing the URL we need to reload page
            this.$router.go(0);
          } else {
            this.$toastr.error("Error while getting user detail.");
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting user detail.");
        }
      );
    },
    resetPassword(userId) {
      this.$api.passwordUserInfoFact(userId).then(
        () => {
          toastr.success("password link updated successfully");
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while updating password.");
        }
      );
    },
    cancelResetPassword() {},
    sendInvite(userId, teamObj) {
      this.$api.resendInviteFact(userId, teamObj).then(
        () => {
          toastr.success("Resent invite successfully");
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while resending invite.");
        }
      );
    },
    siteTeamStatusToggleParent(item) {
      const data = {
        status: item.status == "Active" ? "Inactive" : "Active"
      };
      swal({
        title: item.status == "Inactive" ? "Are you sure you want to activate this Site team member from this site?" : "Are you sure you want to deactivate this Site team member from this site?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4c8ce4",
        cancelButtonColor: "#4c8ce4",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$api.activateTeamMemberFact(this.$route.params.userId, item.siteId, item.studyId, data).then(
            () => {
              this.getUserDetails(this.userId);
              if (data.status === "Inactive") {
                this.$toastr.success("Team member deactivated successfully");
              }
              if (data.status === "Active") {
                this.$toastr.success("Team member activated successfully");
              }
            },
            error => {
              this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the site details.");
            }
          );
        } else {
          this.hide();
        }
      });
    },
    studyTeamActiveStatusParent(item) {
      const data = {
        status: item.status == "Active" ? "Inactive" : "Active"
      };
      swal({
        title: "Are you sure you want to deactivate this Study team member from this site?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4c8ce4",
        cancelButtonColor: "#4c8ce4",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        const userId = [];
        userId.push(this.userId);
        if (dismiss === "cancel") {
          this.$api.studyTeamDisassociateFact(item.studyId, userId).then(
            () => {
              this.getUserDetails(this.userId);
              if (data.status === "Inactive") {
                this.$toastr.success("Team member deactivated successfully");
              }
              if (data.status === "Active") {
                this.$toastr.success("Team member activated successfully");
              }
            },
            error => {
              this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the site details.");
            }
          );
        } else {
          this.hide();
        }
      });
    },
    studyTeamDeactiveStatusParent(item) {
      const data = {
        status: item.status == "Active" ? "Inactive" : "Active"
      };
      swal({
        title: "Are you sure you want to activate this Study team member from this site?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4c8ce4",
        cancelButtonColor: "#4c8ce4",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          const userId = [];
          userId.push(this.userId);
          this.$api.studyTeamAssociateFact(item.studyId, userId).then(
            () => {
              this.getUserDetails(this.userId);
              if (data.status === "Inactive") {
                this.$toastr.success("Team member deactivated successfully");
              }
              if (data.status === "Active") {
                this.$toastr.success("Team member activated successfully");
              }
            },
            error => {
              this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the site details.");
            }
          );
        } else {
          this.hide();
        }
      });
    },
    dataAccessChangeParent(item, showToast = true, onError) {
      this.$api.updateDataAccessFact(item.studyId, item.userId, item.userDataAccessType).then(
        () => {
          if (showToast) {
            this.$toastr.success("User data access type updated successfully");
          }
        },
        error => {
          if (onError) {
            onError(error);
          } else {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while updating the user data access type.");
          }
        }
      );
    },
    showErrorMsg(error, type) {
      if (error.items && error.items.length > 0) {
        if (error.items[0].msg == `The ${type} field is required.`) {
          return type === "firstName" ? "First name is required" : "Last name is required";
        } else if (error.items[0].msg == `The ${type} field format is invalid.`) {
          return "Alphabetic entries only are allowed";
        }
      }
    },
    checkHyphen(teamObj) {
      const regex = /[a-zA-Z]/;
      let checkflag = false;
      if (regex.test(teamObj.firstName) && regex.test(teamObj.lastName)) {
        checkflag = true;
      } else {
        checkflag = false;
        if (!regex.test(teamObj.firstName)) {
          this.$toastr.error("First Name is invalid");
        } else if (!regex.test(teamObj.lastName)) {
          this.$toastr.error("Last Name is invalid");
        }
      }
      return checkflag;
    },
    checkPhoneValidation() {
      let validFlag = true;
      if (!this.validMobile && this.userDetails.phoneNumber && this.userDetails.phoneNumber.length > 0) {
        validFlag = false;
        this.$toastr.error("Phone number is invalid");
      }
      if (!this.validWork && this.userDetails.workNumber && this.userDetails.workNumber.length > 0) {
        validFlag = false;
        this.$toastr.error("Work number is invalid");
      }
      return validFlag;
    },
    isSiteTeamRole(userRole) {
      let isSiteMember = false;
      for (const role of this.siteRoles) {
        if (userRole === role.value) {
          isSiteMember = true;
          return isSiteMember;
        }
      }
    },
    isStudyTeamRole(userRole) {
      let isStudyMember = false;
      for (const role of this.roleoles) {
        if (userRole === role.value) {
          isStudyMember = true;
          return isStudyMember;
        }
      }
    },
    updateUserRole(userId, teamObj) {
      this.$api.updateUserInfoFact(userId, teamObj).then(
        () => {
          toastr.success("users updated successfully");
          this.$router.push({ name: "users" });
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while updating users.");
        }
      );
    },
    closeDownloadModal() {
      window.$("#download-report-modal").modal("hide");
      window.$("#download-report-modal").on("hidden.bs.modal", function() {
        $("body").removeClass("modal-open");
      });
    },
    onFileChange() {
      const fd = new FormData();
      const input = window.document.getElementById("file_upload");
      fd.append("file", input.files[0]);
      this.setImportValue = fd;
      this.uploadFileName = input.files[0].name;
      Papa.parse(input.files[0], {
        complete: results => {
          const data = results.data;
          this.fileLength = data.filter(row => row.some(cell => cell.trim() !== '')).length - 1;
          if (this.awsCognitoAuthentication && data[0].length === 8 && data[1].length === 8 && data.length - 1 > 0 && (data[0][0] === "First Name" || data[0][0].trim() === "First Name") && data[0][1] === "Last Name" && data[0][2] === "Email" && data[0][3] === "Mobile Phone Number" && data[0][4] === "Role" && data[0][5] === "Study ID" && data[0][6] === "Site ID" && data[0][7] === "IDP Username") {
            window.$("#user-import-modal").modal("show");
          } 
          else if (!this.awsCognitoAuthentication && data[0].length === 7 && data[1].length === 7 && data.length - 1 > 0 && (data[0][0] === "First Name" || data[0][0].trim() === "First Name") && data[0][1] === "Last Name" && data[0][2] === "Email" && data[0][3] === "Mobile Phone Number" && data[0][4] === "Role" && data[0][5] === "Study ID" && data[0][6] === "Site ID") {
            window.$("#user-import-modal").modal("show");
          }
          else {
            this.$toastr.error("Uploaded file is not in the expected format. Please use the batch upload template.");
          }
        }
      });
      window.document.getElementById("file_upload").value = null;
    },
    closeImportModal() {
      window.$("#user-import-modal").modal("hide");
      this.setImportValue = null;
      window.$('#file_upload[type="file"]').val(null);
    },
    importCSV(setImportValue) {
      this.closeImportModal();
      window.$("#uploading-modal").modal("show");
      this.uploadingValue = 0;
      this.$api.importUserDataFact(setImportValue).then(
        response => {
          this.downloadList = response.body;
          if (this.downloadList.importUsersCount > 0) {
            this.$toastr.success(`${this.downloadList.importUsersCount} user(s) successfully uploaded.`);
          }
          this.setImportValue = null;
          setTimeout(() => {
            this.hideUploadShowDownload();
          }, 1000);
        },
        error => {
          setTimeout(() => {
            this.hideUploadShowDownload();
          }, 1000);
          this.setImportValue = null;
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while uploading users csv.");
        }
      );
    },
    downloadTemplate() {
      const clientId = localStorageService.getItem("clientId");
      const apiURL = `${process.env.VUE_APP_API_BASE_URL}/api/v1/studymanagement/downloadusertemplate`;
      axios({
        url: apiURL,
        method: "GET",
        responseType: "blob",
        headers: {
          clientId: clientId,
          Authorization: localStorageService.getItem("token")
        }
      }).then(
        response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");
          fileLink.setAttribute("href", fileURL);
          fileLink.setAttribute("download", "import_user.zip");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$toastr.success("Template downloaded successfully.");
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while downloading template.");
        }
      );
    },
    getDateStamp() {
      const now = new Date();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      const year = now.getFullYear();
      const hours = now.getHours();
      const mins = `0${now.getMinutes()}`.slice(-2);
      return `${month}-${day}-${year}-${hours}-${mins}`;
    },
    exportCSV() {
      const fileName = `users_${this.getDateStamp()}.csv`;
      const ua = navigator.userAgent.toLowerCase();
      let type = "";
      if (ua.indexOf("safari") !== -1) {
        if (!(ua.indexOf("chrome") > -1 || ua.indexOf("crios") > -1)) {
          type = "attachment/csv;charset=utf-8";
        }
      }
      type = "text/csv;charset=utf-8";
      const list = [];
      if (this.downloadList && this.downloadList.skippedUsers) {
        this.downloadList.skippedUsers.forEach(element => {
          list.push({
            "First Name": element.firstName,
            "Last Name": element.lastName,
            Email: element.email,
            "Mobile Phone Number": element.mobilePhoneNumber,
            Role: element.role,
            "Study ID": element.studyId,
            "Site ID": element.siteId,
            Status: "failed",
            "Failure reason": element.reason
          });
        });
      }
      if (this.downloadList && this.downloadList.importUsers) {
        this.downloadList.importUsers.forEach(element => {
          list.push({
            "First Name": element.firstName,
            "Last Name": element.lastName,
            Email: element.email,
            "Mobile Phone Number": element.mobilePhoneNumber,
            Role: element.role,
            "Study ID": element.studyId,
            "Site ID": element.siteId,
            Status: "imported",
            "Failure reason": element.reason
          });
        });
      }
      const csv = Papa.unparse(list);
      const blob = new Blob([csv], { type });
      FileSaver.saveAs(blob, fileName);
    },
    hideUploadShowDownload() {
      window.$("#uploading-modal").modal("hide");
      window.$("#download-report-modal").modal("show");
      window.$("#download-report-modal").on("shown.bs.modal", function() {
        $("body").addClass("modal-open");
      });
      this.uploadingValue = 0;
    }
  },
  components: { mainHeader, Copyright, studySiteAssociation, assignedStudies }
};
</script>

<style scoped lang="scss">
.btn {
  font-size: 14px;
}

.form-control[disabled],
fieldset[disabled] .form-control {
  cursor: not-allowed;
}

.users-bg {
  min-height: 100vh;
  background-color: #f5f8fa;
  background-blend-mode: soft-light;
  height: 100%;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.maroon_color {
  color: #ff7171 !important;
}
h1,
h2 {
  font-weight: 0px;
  font-family: Helvetica;
}

h3 {
  padding-bottom: 60px;
  color: black;
}

.panel-body {
  min-height: 200px;
  height: 200px;
}

.studies_list {
  max-width: 1200px;
  margin: auto;
}

.heading {
  font-size: 24px;
  font-weight: 200;
}

.header_row {
  padding-bottom: 20px;
}

.fontStyle {
  font-family: sans-serif;
  font-size: 4rem;
  margin-bottom: 50px;
  margin-top: 10px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #fff;
  text-decoration: none;
  font-size: 25px;
}

.date_val {
  color: #aaa;
  font-size: 12px;
}

button {
  cursor: pointer;
}

.outline-active {
  background: none;
  border: 1px solid #01b7fe;
  color: #01b7fe;
}

.outline-inactive {
  background: none;
  border: 1px solid #8c8c8c;
  color: #8c8c8c;
}

p {
  font-size: 15px;
}

.input-display {
  display: none;
}

/deep/ .col {
  padding: 0px !important;
}

.study-card {
  background-color: #f5f8fa;
  border: none !important;
  padding: 10px 10px 10px 10px;
}

.new-card {
  background-color: #01b7fe;
  text-align: center;
  height: 200px;
  padding-top: 80px;
}

.bottom_footer {
  position: relative;
  bottom: 0px;
  width: 100%;
  padding-top: 20px;
  color: #fff;
}

.header {
  padding-top: 20px;
  padding-bottom: 10px;
}

.user-icon {
  padding-right: 10px;
  color: yellow;
}

.logout_link {
  line-height: 12px;
  font-size: 14px;
}

.team-member {
  font-size: 30px;
  line-height: 1.87;
}

.search-pad {
  padding: 6px 40px;
}

.select-style {
  background: rgba(22, 59, 78, 0.7);
  color: #fff;
}

.search-color {
  color: #333;
}

table {
  color: #4a4a4a;
}

td {
  border: none;
}

th {
  color: #959fa4;
}

.view-color {
  color: #00b1ff;
  cursor: pointer;
}

.custom-button {
  width: 160px;
  height: 40px;
  border-radius: 100px;
  background-color: #195877;
}

.custom-button:hover {
  color: #fff;
}

.card-container {
  background-color: #fff;
  padding: 10px;
}

.team-card {
  color: #959fa4;
}
.header-container {
  padding: 15px;
}
.add-team-header {
  font-size: 22px;
  color: #4a4a4a;
}
.import-btn {
  height: 30px;
  border-radius: 4px;
  border: solid 1px #1e8fe1;
  background-color: #ffffff;
  color: #1e8fe1;
  cursor: pointer;
  font-size: 14px;
  line-height: 15px;
  input[type="file"] {
    display: none;
  }
}
.custom-file-upload {
  cursor: pointer;
  margin-bottom: 0;
}
.download-report-modal {
  .modal-content {
    padding: 15px 15px 15px 24px;
  }
  .modal-header {
    padding: 0;
  }
  h3 {
    padding-bottom: 8px;
    font-size: 24px;
  }
}
.uploading-modal {
  .modal-content {
    padding: 15px 15px 15px 24px;
  }
  h3 {
    padding-bottom: 8px;
  }
}
.user-import-modal {
  .modal-content {
    padding: 15px 15px 15px 24px;
  }
  .modal-header {
    padding: 0;
  }
  .modal-title {
    color: #5b5b5e;
    padding-bottom: 10px;
    font-size: 26px;
  }
  .modal-description {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 1rem;
  }
  .cancel-btn {
    color: #fff;
    background-color: #4a4a4a;
    border-color: #4a4a4a;
    border-radius: 4px;
  }
}
.blue-btn {
  color: #fff;
  background-color: #3770dc;
  border-color: #3770dc;
  border-radius: 4px;
}
.height-250 {
  height: 250px;
}
.width100 {
  width: 100px !important;
}
.width-350 {
  width: 350px !important;
  min-width: 350px !important;
}
.width-650 {
  width: 650px !important;
  min-width: 650px !important;
}
.inner-card {
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 5px;
  font-size: 14px;
  box-shadow: none !important;
}

.inner-card-value {
  font-size: 20px;
  color: #4a4a4a;
  box-shadow: none !important;
  width: 77%;
  height: 30px !important;
  cursor: pointer;
  border-radius: 3px !important;
}

.card-height {
  height: 150px;
}

.edit-profile-btn {
  width: 130px;
  height: 40px;
  border-radius: 100px;
  background-color: #ff7171;
  color: #fff;
}
.edit-profile-btn:hover {
  color: #fff;
}

.full-width {
  width: 100%;
}

.reset-password {
  position: absolute;
  bottom: 5px;
  right: 5px;
  text-decoration: underline;
  color: #4a4a4a;
  cursor: pointer;
}

.save-btn {
  width: 90px;
  height: 34px;
  border-radius: 3px;
  border: solid 2px #4c8ce4;
  background-color: #4c8ce4;
  color: #fff;
}
.cancle-margin {
  margin-right: -11px !important;
}
.cancel-btn {
  width: 130px;
  border-radius: 100px;
  background-color: #fff;
  color: #b8c7ce;
}

.resend-invite {
  width: 110px;
  height: 26px;
  border-radius: 100px;
  background-color: #f16559;
  color: #fff;
  font-size: 12px;
  line-height: 10px;
  float: right;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
  padding-left: 0;
}

.width60 {
  width: 60%;
}

.close-style {
  padding-top: 22px !important;
  outline: none !important;
}

.modal-text {
  font-size: 26px;
  padding-top: 10px;
  padding-left: 15px;
}

.modal-instruction {
  color: #959fa4;
  padding-bottom: 10px;
}

.yes-btn {
  background-color: #1f95f2;
  margin: auto;
}

.yes-btn:hover {
  color: #fff;
}

.modal-position {
  top: 150px !important;
  right: 100px;
}

.select-font {
  font-size: 16px;
  color: #888;
}

.first-name-value {
  font-size: 16px !important;
  color: #4a4a4a;
  border: none;
  outline: none;
}

input,
select:disabled {
  background-color: #fff !important;
}
.form-control {
  padding: 0 !important;
}

@media (max-width: 767px) {
  .modal-position {
    top: 0 !important;
    right: 0 !important;
  }
}
.profile-info-2 {
  width: 1108px;
  height: 211px;
  // margin: 17px 165px;
  padding: 28px 28px 25px 31px;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
}
.table-card {
  color: #959fa4;
  margin-top: -28px;
}
.StudY-table-head {
  width: 32px;
  height: 12px;
  margin: 5px 112px 9px 31px;
  opacity: 0.5;
  font-family: Roboto-Regular;
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #666669;
}
.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  top: 0px;
  left: 6px;
}
/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
/* Rounded sliders */
.un-bld-Lbl-Txt {
  color: #666669 !important;
  opacity: 0.5;
  position: relative;
  top: -14px;
  right: 1px;
}
.bld-Lbl-Txt {
  color: #666669 !important;
  opacity: 0.5;
  position: relative;
  top: -14px;
  left: 10px;
}
.help_icon {
  color: #b8c7ce;
  border: none !important;
  outline: none !important;
}
.info-msg {
  position: relative;
  left: 13px;
  top: -14px;
}
.Deactivate-from-site-study {
  font-family: Roboto-Regular;
  color: #f16559;
}
.activate-txt {
  font-family: Roboto-Regular;
  color: #1e8fe1;
}
.name-txt {
  width: 89px;
  height: 20px;
  margin: 0 182px 6px 15px;
  font-family: Roboto-Regular;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #bfbfbf;
  padding-top: 20px;
}
.input-txt {
  width: 252px;
  margin: 2px 96px 22px 15px;
  opacity: 0.7;
  font-family: Roboto-Regular;
  font-size: 18px;
  line-height: normal;
  color: #666669;
  box-shadow: none !important;
  border: none;
  outline: none;
  box-shadow: none !important;
}
.input-txt-2 {
  width: 255px;
  margin: -2px 66px 4px -42px;
  padding: 3px 0px 3px 9px;
  opacity: 0.7;
  font-family: Roboto-Regular;
  font-size: 18px;
  line-height: normal;
  color: #666669;
  box-shadow: none !important;
  border: 1px solid #bbb;
  outline: none;
  box-shadow: none !important;
  border-radius: 4px;
}
.Change-password {
  margin: 35px 91px 4px 51px;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4c8ce4;
  cursor: pointer;
}
.edit-box {
  margin: 32px 5px 8px -79px;
  padding: 5px 20px 7px 20px;
  border-radius: 3px;
  border: solid 2px #d3dfe4;
  font-family: Roboto-Regular;
  font-size: 12px;
  color: #4c8ce4;
  text-align: center;
  cursor: pointer;
  height: 32px !important;
}
.ml-405 {
  margin-left: 405px !important;
}
.vue-tel-input {
  width: 335px;
}
.input-txt-3 {
  width: 298px;
  margin: -2px 66px 4px 12px;
  padding: 3px 0px 3px 9px;
  opacity: 0.7;
  font-family: Roboto-Regular;
  font-size: 18px;
  line-height: normal;
  color: #666669;
  box-shadow: none !important;
  border: 1px solid #bbb;
  outline: none;
  box-shadow: none !important;
  border-radius: 4px;
}
.vue-tel-input-1 {
  width: 298px;
}
.info-circle-div {
  width: 280px;
  height: 80px;
  background-color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #666669;
  padding: 13px 16px 19px 13px;
  position: absolute;
  border-radius: 3px;
  margin-left: 150px;
  margin-top: 0px;
  box-shadow: 1px 1px #d3deef;
}
.setting-btn-text {
  position: relative;
  right: 5px;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #b0bac9;
}
.switch-option {
  float: left;
  width: 100%;
}
.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  float: left;
  margin-right: 10px;
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.inner-card-value-study {
  font-size: 17px;
  // color: #4a4a4a;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  width: 100%;
  height: 30px !important;
  cursor: pointer;
  border-radius: 3px !important;
  border: none;
}
.studies-managing {
  margin-top: 1px !important;
}
.card-height-2 {
  height: 63px;
}
.Change-password-2[data-v-d54daf4a] {
  margin: 57px 9px 4px 51px;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4c8ce4;
  cursor: pointer;
}
.mt-95 {
  margin-top: 95px;
}
.color_profile {
  color: #9b9b9b;
  font-family: Roboto-Regular;
  font-size: 15px;
}
.color_team {
  color: #4c8ce4;
  font-family: Roboto-Regular;
  font-size: 15px;
}
.color_top {
  color: #666669;
}
.color_e74c3c {
  color: #e74c3c;
}
.toggle-margin {
  margin-left: -167px !important;
}
.edit-email-input {
  border: 1px solid #bfbfbf !important;
  color: #888 !important;
  padding: 3px 0px 3px 9px;
  border-radius: 4px;
  font-family: Roboto-Regular;
  font-size: 18px;
  min-width: 255px;
  margin-left: 14px;
}
.minWidthSelect {
  width: 85%;
}
.additional-details-sso {
  border-bottom: 1px solid #d4d4d3;
  margin-top: 40px;
  margin-left: 13px;
  padding-top: 20px;
  padding-bottom: 23px;
  .additional-sso-title {
    color: #4a4a4a;
    font-family: Roboto-Medium;
    font-size: 16px;
    display: flex;
    align-items: center;
    &::after {
      content: "";
      flex: 1;
      margin-left: 1rem;
      height: 1px;
      background-color: #d4d4d3;
      margin-top: 15px;
    }
  }
  .desc {
    margin-top: 20px;
    margin-bottom: 25px;
    color: #666669;
    font-family: Roboto-Regular;
    font-size: 12px;
  }

  .form-group {
    label {
      display: block;
      color: #bfbfbf;
      font-weight: bold;
      font-size: 12px;
    }
    .read-only-username {
      font-size: 18px;
      color: #666669;
      opacity: 0.7;
      border: solid 1px #bbbabb;
      border-radius: 4px;
      padding: 7px 10px;
      min-height: 39px;
    }
    input {
      margin: 0;
      width: 100%;
      padding: 7px 10px;
      line-height: inherit;
    }
  }
}
</style>
